import React from 'react';
import {observer} from 'mobx-react';
import {Panel, ActionLink} from 'components';
import {FormattedMessage} from 'react-intl';
import DeleteGoalModal from './DeleteGoalModal';
import ProgressUpdateForm from './ProgressUpdateForm';

const GoalLinks = observer(({uiState}) => {
  const {goal} = uiState;
  if (!goal.canPatch) return null;

  return (
    <div className='px1 dropdown inline-block clickable absolute top-0 right-0'>
      <i className='material-icons submarine align-middle' data-toggle='dropdown'>
        {'more_horiz'}
      </i>
      <ul className='dropdown-menu right-0'>
        <li><ActionLink className='py1 px2 regular jumbo' onClick={() => uiState.openEditGoalModal(goal)}>
          <FormattedMessage id='Edit' />
        </ActionLink></li>
        <li><ActionLink className='py1 px2 regular jumbo' onClick={() => uiState.openDeleteGoalModal(goal)}>
          <FormattedMessage id='Delete' />
        </ActionLink></li>
      </ul>
    </div>
  );
});

const GoalDetails = observer(({uiState}) => {
  const {goal} = uiState;

  return (
    <Panel>
      <Panel.Header title={goal.title} description={goal.description}>
        <GoalLinks uiState={uiState} />
      </Panel.Header>
      <div className='clearfix mxn2'>
        <div className='col col-4 px2'>
          <span className='medium'>
            <FormattedMessage id='goals.Start Date:'/>
          </span>
          <span className='jumbo'>
            {goal.startDateView}
          </span>
        </div>
        <div className='col col-4 px2'>
          <span className='medium'>
            <FormattedMessage id='goals.End Date:'/>
          </span>
          <span className='jumbo'>
            {goal.endDateView}
          </span>
        </div>
        <div className='col col-4 px2'>
          <span className='medium'>
            <FormattedMessage id='goals.Progress Updates:'/>
          </span>
          <span className='jumbo'>
            {goal.progressUpdates.length}
          </span>
        </div>
      </div>
      <ProgressUpdateForm uiState={uiState} />
      <DeleteGoalModal uiState={uiState} />
    </Panel>
  );
});

export default GoalDetails;
